import React from "react";
import { Button } from "@dhis2/ui";

export default function RatingInput({ value, disabled, locked, onChange, onConfirm, ariaLabel }) {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <select
        value={value || ""}
        onChange={handleChange}
        disabled={disabled || locked}
        aria-label={ariaLabel}
        style={{
          padding: "6px 8px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          fontSize: "14px",
          minWidth: "60px",
        }}
      >
        <option value="">-</option>
        {[1, 2, 3, 4, 5].map((num) => (
          <option key={num} value={num}>{num}</option>
        ))}
      </select>
      {!locked && onConfirm && (
        <Button small primary onClick={onConfirm} disabled={disabled || !value}>
          ✓
        </Button>
      )}
    </div>
  );
}